import { render, staticRenderFns } from "./PiSignature.vue?vue&type=template&id=61c88c15&scoped=true&"
import script from "./PiSignature.vue?vue&type=script&lang=js&"
export * from "./PiSignature.vue?vue&type=script&lang=js&"
import style0 from "./PiSignature.vue?vue&type=style&index=0&id=61c88c15&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c88c15",
  null
  
)

export default component.exports